import dayjs from 'dayjs'
import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { useStore } from 'store/useStore'
import { ItemBox } from 'sections/LKSection/shared/components/UI/ItemBox/ItemBox'
import { Status } from 'sections/LKSection/shared/components/UI/Status/Status'
import { Flex, Rate, Text } from 'components/uiKit'
import { getTicketItemRoute } from 'utils/helpers/routes/getRoutes'
import { useResize } from 'utils/hooks/useResize'
import { DATE_FORMAT_WITH_TIME } from 'shared/constants/values'

import { TicketKeys, ticketStatusTranslator } from '../../data'
import { Ticket } from '../../stores/entity/Ticket'

type TicketItemHeaderProps = {
  ticket: Ticket
}

const getKey = (key: string) => `${TicketKeys.ticketPage}.${key}`

export const TicketItemHeader = observer(({ ticket }: TicketItemHeaderProps) => {
  const { viewTicketUiStore: uiStore } = useStore()

  const { isTablet } = useResize()
  const { t } = useTranslation()
  const navigate = useNavigate()

  const firstSentenceInDescription = ticket.description.split('\n')[0]
  const description =
    firstSentenceInDescription.length > 70
      ? firstSentenceInDescription.slice(0, 70) + '...'
      : firstSentenceInDescription

  const ticketItemClickHandler = () => {
    uiStore.setSelectedTicket(ticket)

    if (ticket.id) {
      navigate(getTicketItemRoute(ticket.id, uiStore.page, uiStore.pageSize))
    }
  }

  return (
    <ItemBox onClick={ticketItemClickHandler} hasNotice={ticket.hasNotice}>
      <Flex
        onClick={ticketItemClickHandler}
        align={isTablet ? 'flex-start' : 'center'}
        justify="space-between"
        gap={isTablet ? 16 : 40}
        vertical={isTablet}
        style={{ width: '100%' }}
      >
        <Flex
          gap={isTablet ? 16 : 32}
          align={isTablet ? 'flex-start' : 'center'}
          justify={isTablet ? 'space-between' : 'flex-start'}
          style={{ width: '100%' }}
          vertical={isTablet}
        >
          <Flex
            justify={isTablet ? 'space-between' : undefined}
            style={{ width: isTablet ? '100%' : 'auto' }}
            align="center"
          >
            <Flex style={{ minWidth: isTablet ? undefined : 100 }}>
              <Status
                title={t(getKey(ticketStatusTranslator[ticket.status].title))}
                type={ticketStatusTranslator[ticket.status].type}
              />
            </Flex>

            <Flex style={{ minWidth: 100 }} vertical>
              <Text>
                ID: <Text copyable>{ticket.id}</Text>
              </Text>
              <Text type="secondary">{dayjs(ticket.createDate).format(DATE_FORMAT_WITH_TIME)}</Text>
            </Flex>
          </Flex>

          <Flex style={{ minWidth: isTablet ? undefined : 100 }} vertical>
            {ticket.canRate && <Text type="danger">{t(getKey('Не оценен'))}</Text>}

            {ticket.ticketGrade !== 0 && (
              <Flex gap={8} align={isTablet ? 'baseline' : 'flex-start'}>
                <Text>{t(getKey('Оценка'))}:</Text>
                <Rate value={ticket.ticketGrade} disabled />
              </Flex>
            )}

            <Text>{ticket.ticketTypeName}</Text>
          </Flex>
        </Flex>

        <Flex style={{ width: isTablet ? '60%' : '300px' }} justify="flex-start">
          <Text>{description}</Text>
        </Flex>
      </Flex>
    </ItemBox>
  )
})
